import styled from "styled-components";

export const ThemeSwitchWrapper = styled.div`
 width: 122.9px;
  background-color: ${props => props.isDark ? '#570bc1' : '#8a3ef41a'};
  display: flex;
  align-items: center;
  gap: 10px;
  padding:4px 12px;
  border-radius: 9999px;
  .ant-switch {
    padding:0px;
    margin-right: 0px !important;
    color:#8a3ef4;
    background-color:  ${props => props.isDark ? '#570bc1 !important' : '#8a3ef41a !important'};
  }
  .ant-switch-checked {
    background-color: #8a3ef4 !important;
    border-color: #8a3ef4 !important;
    border:none !important;
  }
  .ant-switch-checked:focus {
    box-shadow: 0 0 0 1px #8a3ef4 !important;
 } 
  
  
.ant-switch-handle:before {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #1e293b;
    border-radius: 9px;
    box-shadow: 0 2px 4px 0 #8a3ef4;
    content: "";
}
`